import React from 'react';
import { observer } from 'mobx-react-lite';
import SmartModal from '../SmartModal/SmartModal';
import CalculationPreviewRenderer from './CalculationPreviewRenderer';

/**
 * Модальное окно предпросмотра расчета/шаблона
 */
const PreviewModal = observer(({
    isOpen,
    onClose,
    data,
    isTemplate = false,
    title
}) => {
    if (!data) return null;

    // Определяем заголовок модалки
    const modalTitle = title || (isTemplate
        ? `Предпросмотр шаблона: ${data.templateName || data.name || 'Без названия'}`
        : `Предпросмотр расчета: ${data.name || 'Без названия'}`
    );

    return (
        <SmartModal
            isOpen={isOpen}
            onClose={onClose}
            modalTitle={modalTitle}
            mode="viewer"
            size="xxl"
            hideFooter={false}
        >
            <CalculationPreviewRenderer
                data={data}
                isTemplate={isTemplate}
            />
        </SmartModal>
    );
});

export default PreviewModal;